module.exports = "<div class=\"container\">\n    <div class=\"main-top\">\n        <img class=\"main-logo\" src=\"assets/img/smartenit-logo.png\">   \n        <h3 class=\"ligth-text\">One account, Different Services</h3>     \n    </div>\n    <register-form></register-form>               \n    \n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/signup/signup.html
// module id = ./src/app/pages/signup/signup.html
// module chunks = main